import { createFileRoute, Link } from "@tanstack/react-router";
import { SetupCopyBlock } from "@/components/setup/SetupCopyBlock";

export const Route = createFileRoute("/docs/scheduling-posts")({
	component: SchedulingPosts,
});

function SchedulingPosts() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">
					Scheduling posts
				</h1>
				<p className="text-sm text-muted-foreground">
					Prepare content in advance and publish at the right time.
				</p>
			</div>
			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>Tell your assistant things like:</p>
				<div className="grid gap-2">
					<SetupCopyBlock
						text="Schedule a post about our product launch for Monday at 9am."
						multiline
					/>
					<SetupCopyBlock
						text="Move my scheduled post to Wednesday afternoon."
						multiline
					/>
					<SetupCopyBlock
						text="Publish the draft about the conference right now."
						multiline
					/>
				</div>
				<p>
					The assistant uses{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postCompose
					</code>{" "}
					to set or change publish times, and{" "}
					<code className="rounded bg-muted px-1.5 py-0.5 text-xs font-mono text-foreground">
						postPublish
					</code>{" "}
					for immediate publishing. You can even set different publish times per
					target when delivery times should differ.
				</p>

				<p>
					Scheduled posts appear on the{" "}
					<strong className="text-foreground">Calendar</strong> in the dashboard
					so you can see everything queued up across all channels.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/deleting-posts"
					className="text-muted-foreground hover:text-foreground transition-colors"
				>
					&larr; Deleting posts
				</Link>
				<Link
					to="/docs/calendar"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Using the calendar &rarr;
				</Link>
			</div>
		</article>
	);
}
